export const SortPaths = [
  'trending',
  'popular'
]



// WEBPACK FOOTER //
// ./assets/js/config/SortPaths.js